import React from "react";
import clsx from 'clsx';
import { Formik } from "formik";
import * as Yup from "yup";
import { TextField, withStyles, Button, FormHelperText, InputLabel, IconButton, Input, InputAdornment, CircularProgress, Typography, FormControl, Divider } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { detectBrowserLanguageCode, withBrowserLanguageOnTop } from "../../sc-translate/appTranslations";
import { Visibility, VisibilityOff } from '@material-ui/icons';
import ForgotPassword from '../ForgotPassword';
import config from "../../../config/config";

const styles = theme => ({
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%",
        marginBottom: '5px',
    },
    btn: { textAlign: 'right' }
});


function LoginForm(props) {
    const { classes, formSettings, initialValues, value, handleClickShowPassword, handleMouseDownPassword, handleSubmit, appTranslations, translations, handleLanguageChange } = props;

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue } = formikProps;

                return (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        <TextField
                            label={translations['username'] || 'Username'}
                            placeholder={translations['username'] || 'Username'}
                            name="Username"
                            fullWidth={true}
                            value={values.Username}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            margin="dense"
                            error={!!(errors.Username && touched.Username)}
                        />
                        <FormControl className={clsx(classes.margin, classes.formControl)}>
                            <InputLabel htmlFor="in-category-1">{translations['password'] || 'Password'}</InputLabel>
                            <Input
                                id="in-category-1"
                                type={value ? 'text' : 'password'}
                                name="Password"
                                value={values.Password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Password && touched.Password)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {value ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>

                        {['dev', 'stage'].includes(config.environment) ? <ForgotPassword /> : null}


                        {formSettings.ButtonSubmit ? (
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                fullWidth={true}
                                disabled={isSubmitting || !(isValid && dirty)}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                            </Button>
                        ) : null}

                        <FormControl className={classes.formControl} margin={"dense"}>
                            <Autocomplete
                                options={withBrowserLanguageOnTop(appTranslations || [])}
                                groupBy={option => option.__group}
                                getOptionLabel={option => option.displayName || ''}
                                getOptionSelected={(option, val) => option.code === val.code}
                                value={
                                    (appTranslations || []).find(
                                        o => o.code === (values.language || detectBrowserLanguageCode() || 'en')
                                    ) || null
                                }
                                onChange={(_event, option) => {
                                    const code = option ? option.code : 'en';
                                    setFieldValue('language', code);
                                    if (handleLanguageChange) handleLanguageChange({ target: { value: code } });
                                }}
                                // Mobile/Work-style: no group headers, just a thin
                                // divider between browser-locale row and the rest.
                                renderGroup={params => [
                                    params.group === 'All languages' && (
                                        <Divider key={`${params.key}-divider`} component="li" />
                                    ),
                                    <ul key={params.key} style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                        {params.children}
                                    </ul>
                                ]}
                                disableClearable
                                blurOnSelect
                                fullWidth
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        name="language"
                                        label={translations['language'] || 'Select language'}
                                        margin="dense"
                                    />
                                )}
                            />
                        </FormControl>
                    </form>
                );
            }}
        </Formik>
    );
}

export default withStyles(styles, { withTheme: true })(LoginForm);
